module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms_jp.313262f9f48b635517108ae25e8326cc.png";